import state from "./state";
import mutations from './mutations'
import actions from './actions'

const getters = {
	getRootState: rootState => rootState,
	
	//获取当前筛项数据
	getFilterErrorInfoSize: (state) => {
		let { errors } = state.resumeErrorInfo
		let list = {
			allLength: 0,
			word: [],
			punc: [],
			miss: []
		}
		Object.keys(errors).forEach(level1Key => {
			let level1Item = errors[level1Key]
			if(level1Item){
				// console.log('level1Key=>>',level1Key, level1Item)
				Object.keys(level1Item).forEach(level2Key => {
					let level2Item = level1Item[level2Key]
					if(level2Item){

						// 技能/证书及其他
						if(level1Key === 'extras'){
								
						} else if( (level1Key === 'edus' || level1Key === 'works' || level1Key === 'orgs' || level1Key === 'infos') && level2Item.errorList){
							let words = level2Item.errorList.filter(item=> item.error_type === 'word' && !item.is_correct)
							let puncs = level2Item.errorList.filter(item=> item.error_type === 'punc' && !item.is_correct)
							let misss = level2Item.errorList.filter(item=> item.error_type === 'miss' && !item.is_correct)
							list.word = [...list.word, ...words]
							list.punc = [...list.punc, ...puncs]
							list.miss = [...list.miss, ...misss]
						}
					}
				})
			}

		})
		// console.log('计算', list)
		list.allLength = list.word.length + list.punc.length + list.miss.length
		return list
	},
	
	// 获取当前简历有几个模块
	getCvDetailModelLength: (state) => {
		// console.log(1111, state.cvDetail.submodule_info)
		// if(!state.cvDetail.submodule_info.sections_position){
		// 	return 0
		// }
		let { sections_position } = state.cvDetail.submodule_info;
		let modelLength = 0
		let arr1 = ['edus', 'opus', 'orgs', 'works']
		let arr2 = ['certificate', 'other', 'interest', 'language', 'skill']
		arr1.forEach(item=>{
			modelLength += state.cvDetail.submodule_info[`${item}_ids`] ? state.cvDetail.submodule_info[`${item}_ids`].length : 0
		})
		arr2.forEach(item=>{
			modelLength += !!state.cvDetail.submodule_info[`${item}_id`] ? 1 : 0
		})
		sections_position.forEach(item => {
			modelLength += item.info_ids.length
		})

		return modelLength
	},
}

export default {
	namespaced: true,
	actions,
	mutations,
	getters,
	state
}
